module.exports = __webpack_public_path__ + "media/images/top_menu_icon/statements-418ae554b8fd6849ea31b7c86d6c5252.png";